import React from "react";
import { cn } from "@/lib/utils";
import { Typography } from "../ui/typography";
import { TruncatedTextTooltip } from "@/components/common/TextTooltip";

type ChipProps = {
  label: string | React.ReactNode;
  value: string | number;
  variant?: "default" | "success" | "warning" | "error" | "danger";
  className?: string;
  onClick?: () => void;
};

export const Chip: React.FC<ChipProps> = ({
  label,
  value,
  variant = "default",
  className,
  onClick,
}) => {
  const variantClasses = {
    default: "border border-gray-300 text-gray-800 bg-gray-50",
    success: "border border-green-700 text-green-700",
    warning: "border border-[var(--declined-bg)]  text-[var(--declined-bg)]  ",
    error: "border border-danger-900 text-danger-900",
    danger:
      "border border-danger-1000 text-danger-1000 dark:border-danger-badge-text dark:text-danger-badge-text",
  };

  // For tooltip, use string representation of label
  const labelText = typeof label === "string" ? label : "Risk Score";
  const fullText = `${labelText}: ${value}`;

  return (
    <span
      onClick={onClick}
      className={cn(
        "inline-flex items-center px-2 py-1 mb-[4px] ml-[6px] mr-[2px] rounded-[4px] h-[30px] overflow-hidden min-w-max-content max-w-[140px]",
        variantClasses[variant],
        onClick && "cursor-pointer",
        className
      )}>
      <TruncatedTextTooltip text={fullText} className='w-full py-2'>
        <Typography variant='semibold-12' className='truncate block w-full'>
          {label}: {value}
        </Typography>
      </TruncatedTextTooltip>
    </span>
  );
};
